import "./training-page.scss";
import { Page } from "modules/Page";

export class TrainingPage extends Page<typeof TrainingPage> {
    public static readonly className = "js-training-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.stickyButtonMobile();
    }

    public stickyButtonMobile() {
        const submitButton = this.rootElement.querySelector(".form-block .EPiServerForms .Form__Element button[type=submit]");

        if (submitButton && submitButton.parentNode) {
            const wrapper = document.createElement('div');
            wrapper.classList.add("apply-button");

            submitButton.parentNode.insertBefore(wrapper, submitButton);       
            wrapper.appendChild(submitButton);
        }

        const isElementInViewport = (el: HTMLElement): boolean => {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.bottom >= document.documentElement.clientHeight
            );
        };

        addEventListener("scroll", () => {
            const windowSize = window.document.body.clientWidth;
            const targetElement = this.rootElement.querySelector("#sticky-button__marker");    

            if (windowSize < 580) {    
                if (targetElement instanceof HTMLElement) {
                    if (!isElementInViewport(targetElement)) {
                        targetElement.classList.add("out-of-view");
                    } else {
                        targetElement.classList.remove("out-of-view");
                    }
                }
            }
        })
    }
}